interface ErrorResponse {
    code: number;
    message: string;
}

export interface QuickbetsXFilterState {
    quickbetsXFilterData: any;
    quickbetsXFilterDataLoading: boolean;
    quickbetsXFilterDataError: ErrorResponse | null;
}


export enum QuickbetsXFilterActionTypes {
    FETCH_QUICKBETS_X_FILTER_DATA = "FETCH_QUICKBETS_X_DATA",
    FETCH_QUICKBETS_X_DATA_FILTER_SUCCESS = "FETCH_QUICKBETS_X_DATA_SUCCESS",
    FETCH_QUICKBETS_X_DATA_FILTER_ERROR = "FETCH_QUICKBETS_X_DATA_ERROR",
}

export type QuickbetsXFilterAction =
    | { type: QuickbetsXFilterActionTypes.FETCH_QUICKBETS_X_FILTER_DATA }
    | { type: QuickbetsXFilterActionTypes.FETCH_QUICKBETS_X_DATA_FILTER_SUCCESS; payload: any[] }
    | { type: QuickbetsXFilterActionTypes.FETCH_QUICKBETS_X_DATA_FILTER_ERROR; payload: any };